import { useCallback } from 'react'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { useNotificationStore } from 'src/feature/notification/store/notification.store'

/**
 * Custom hook for validating skill data before saving
 * @returns Validation function that shows error messages and returns boolean
 */
export const useSkillValidation = () => {
  const { translation } = useLocalizationStore()
  const notificationStore = useNotificationStore()

  const validateSkillData = useCallback(
    (editedSkillName: string, editedSkillHint: string, editedDescriptions: Record<string, string>) => {
      // Check if any required field is empty
      const isInvalid = !editedSkillName.trim() || !editedSkillHint.trim() || Object.values(editedDescriptions).some(desc => !desc.trim())

      if (isInvalid) {
        notificationStore.enqueueError(translation.pages.myTeam.errorMsg.fieldCannotBeEmpty())

        return false
      }

      return true
    },
    [translation, notificationStore],
  )

  return validateSkillData
}
